import {EmployeeBranchSelector} from "./employeeBranchSelector";
import {IComponentOptions} from "angular";
import {BranchesServiceName, ToastNotificationServiceName} from "../../../utils/names/serviceNames";

export class MultiEmployeeBranchSelector extends EmployeeBranchSelector {

    public static instance: IComponentOptions = {
        controller: [BranchesServiceName, ToastNotificationServiceName, '$element', MultiEmployeeBranchSelector],
        template: require('./multiEmployeeBranchSelector.html'),
        bindings: {
            branchesChange: '<',
            onValueChange: '<'
        }
    };





}